import csvIcon from "@/assets/images/fileTypes/csv.webp";
import docIcon from "@/assets/images/fileTypes/doc.webp";
import pdfIcon from "@/assets/images/fileTypes/pdf.webp";
import pptIcon from "@/assets/images/fileTypes/ppt.webp";
import txtIcon from "@/assets/images/fileTypes/txt.webp";
import wordIcon from "@/assets/images/fileTypes/word.webp";
import xlsIcon from "@/assets/images/fileTypes/xls.webp";
import React, { useState } from "react";
import { Row } from "reactstrap";
import FileViewer from "./Modals/FileViewer";
import { PhotoViewer } from "./PhotoViewer";

const formatSize = (bytes) => {
    if (!bytes || bytes === 0) return "0 B";
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(2)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
};

const isImage = (fileName) => {
    const ext = fileName.split('.').pop().toLowerCase();
    return ["png", "jpg", "jpeg", "webp", "gif"].includes(ext);
};

const fileTypeIcons = {
    pdf: pdfIcon,
    csv: csvIcon,
    doc: docIcon,
    docx: wordIcon,
    ppt: pptIcon,
    pptx: pptIcon,
    txt: txtIcon,
    xls: xlsIcon,
    xlsx: xlsIcon,
};

const getFileTypeIcon = (fileName) => {
    const ext = fileName.split('.').pop().toLowerCase();
    return fileTypeIcons[ext] || null;
};

const S3_BASE = process.env.REACT_APP_S3;

const getFullUrl = (path) => `${S3_BASE}${path}`;

const MultipleFileRenderer = ({ files = [] }) => {
    const [openPrint, setOpenPrint] = useState(false);
    const [printUrl, setPrintUrl] = useState("");
    const [printName, setPrintName] = useState("");
    const [originalUrl, setOriginalUrl] = useState("");

    const handlePrint = React.useCallback(() => setOpenPrint(false), []);

    const openFileViewer = (file) => {
        const fullRoute = getFullUrl(file.original);
        const ext = file.fileName.split('.').pop().toLowerCase();

        const viewerUrl = ["doc", "docx", "xls", "xlsx"].includes(ext)
            ? `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(fullRoute)}`
            : fullRoute;

        setPrintUrl(viewerUrl);
        setOriginalUrl(getFullUrl(file.original));
        setPrintName(file.fileName);
        setOpenPrint(true);
    };

    return (
        <>
            <FileViewer data={printUrl} originalUrl={originalUrl} onCloseClick={handlePrint} show={openPrint} moduleName={`View: ${printName}`} />
            <Row className="g-2">
                {files.map((file) => {
                    const isImg = isImage(file.fileName);
                    const previewSrc = file.thumbnail || file.small || file.medium || file.original;
                    const fullSrc = file.small || file.medium || file.large || file.original;

                    return (
                        <div className="col-auto" key={file.fileId}>
                            {isImg ? (
                                <PhotoViewer src={getFullUrl(fullSrc)}>
                                    <div
                                        className="d-flex border border-dashed p-2 rounded position-relative align-items-center cursor-pointer"
                                        style={{ minWidth: 200 }}
                                    >
                                        <div className="flex-shrink-0">
                                            <img
                                                src={getFullUrl(previewSrc)}
                                                alt={file.fileName}
                                                style={{ width: 40, height: 40, objectFit: "cover", borderRadius: 4 }}
                                            />
                                        </div>
                                        <div className="flex-grow-1 ms-2">
                                            <h6 className="mb-1 text-truncate" style={{ maxWidth: 180 }}>{file.fileName}</h6>
                                            <small>{formatSize(file.fileSize)}</small>
                                        </div>
                                    </div>
                                </PhotoViewer>
                            ) : (
                                <div
                                    className="d-flex border border-dashed p-2 rounded position-relative align-items-center cursor-pointer"
                                    style={{ minWidth: 200 }}
                                    onClick={() => openFileViewer(file)}
                                >
                                    <div className="flex-shrink-0">
                                        {getFileTypeIcon(file.fileName) ? (
                                            <img
                                                src={getFileTypeIcon(file.fileName)}
                                                className="img-thumbnail avatar-sm"
                                                style={{ width: "40px", height: "40px" }}
                                                alt={file.fileName}
                                            />
                                        ) : (
                                            <i className={`fs-17 ${getFileIcon(file.fileName)}`}></i>
                                        )}
                                    </div>
                                    <div className="flex-grow-1 ms-2">
                                        <h6 className="mb-1 text-truncate" style={{ maxWidth: 180 }}>{file.fileName}</h6>
                                        <small>{formatSize(file.fileSize)}</small>
                                    </div>
                                </div>
                            )}
                        </div>
                    );
                })}
            </Row>
        </>
    );
};

export default React.memo(MultipleFileRenderer);
